class Sliding {
  body: HTMLBodyElement;
  mainSlidingOpen = 'mso';
  subSlidingOpen = 'open';
  btnSlide: HTMLButtonElement[];
  slidingList: HTMLUListElement;
  subSlidingLinks: HTMLLIElement[];
  subSlidingBack: HTMLLinkElement[];

  constructor() {
    this.body = document.querySelector('body');
    this.btnSlide = [].slice.call(document.querySelectorAll('.btnSlide'));
    this.slidingList = document.querySelector('.slidingList');
    if (this.slidingList) {
      this.subSlidingLinks = [].slice.call(this.slidingList.querySelectorAll('.menu-item-has-children'));
      this.subSlidingBack = [].slice.call(this.slidingList.querySelectorAll('.goback'));
      this.slide();
      this.subSlide();
      this.closeTargetList();
      this.goBack();
    }
  }
  
  slide() {
    this.btnSlide.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!this.body.classList.contains(this.mainSlidingOpen)) {
          this.body.classList.add(this.mainSlidingOpen);
        } else {
          this.closeSlide();
        }
      });
    });

  }

  subSlide() {
    this.subSlidingLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;
        if (!target.classList.contains(this.subSlidingOpen) && target.classList.contains('menu-item-has-children')) {
          link.classList.add(this.subSlidingOpen);
        }
      });
    })
  }

  closeSlide() {
    this.body.classList.remove(this.mainSlidingOpen);
    this.subSlidingLinks.forEach((openSlide: HTMLLIElement) => {
      openSlide.classList.remove(this.subSlidingOpen);
    });
  }

  goBack() {
    this.subSlidingBack.forEach(back => {
      back.addEventListener('click', () => {
        const parent: HTMLElement = back.parentElement.parentElement;
        if (parent.classList.contains(this.subSlidingOpen)) {
          parent.classList.remove(this.subSlidingOpen);
        }    
      });
    })
  }

  closeTargetList() {
    document.addEventListener('click', (e) => {
      const target = e.target as HTMLElement;
      if ( !target.classList.contains('slidingList') && !target.closest('.slidingList') && !target.closest('.opnhh') ) {
        this.closeSlide();
      }
    });
  }
}

new Sliding;